import comfortVoter from './comfort-voter'
import content from './content'
import deletion from './deletion'
import edit from './edit'
import form from './form'
import selection from './selection'
import search from './search'

export default {
    comfortVoter,
    content,
    deletion,
    edit,
    form,
    selection,
    search
}
